import React, { useCallback } from 'react';

import { FiHome, FiPlus } from 'react-icons/fi';
import { FaLongArrowAltRight, FaLongArrowAltLeft } from 'react-icons/fa';
import { AiOutlineClose, AiOutlineEdit } from 'react-icons/ai';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  ContainerMyAddress,
  MyAddressTitle,
  AddressTitle,
  AddressMore,
  AddressItemContent,
  AddressItemAdd,
  AddressItemAddLogo,
  AddressItemAddText,
  ContainerAddressLists,
  AddressItem,
  AddressLogo,
  AddressStreet,
  AddressNeigh,
  AddressCityState,
  AddressCity,
  AddressState,
  AddressSeparator,
  AddressZip,
  AddressAction,
  AddressItemClosed,
  AddressItemUpdate,
} from './styles';
import { StoreState } from '../../store/createStore';
import {
  userAddressRemovedRequest,
  userAddressSelectedRequest,
  customerCEPSuccess,
} from '../../store/modules/auth/actions';

import { UserAddresses } from '../../store/modules/auth/types';
import { useTranslation } from '../../hooks/useTranslation';

interface CardAddressProps {
  title: string;
  summary?: boolean;
  nobtnNew?: boolean | false;
}

const CardAddress: React.FC<CardAddressProps> = ({
  title,
  summary: summaryFlag,
  nobtnNew,
}: CardAddressProps) => {
  const { user } = useSelector((state: StoreState) => state.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const {onTranslation : t} = useTranslation();

  const handleAddressSelected = useCallback(
    address => {
      dispatch(
        userAddressSelectedRequest(
          address,
        ),
      );
    },
    [dispatch],
  );

  const handleAddressRemoved = useCallback(
    address_id => {
      //konsole.log('handleAddressRemoved->summary:', summary);

      dispatch(userAddressRemovedRequest(address_id));
    },
    [dispatch],
  );

  const handleAddressUpdate = useCallback((address: UserAddresses) => {
      history.push('/account/address');
      dispatch(customerCEPSuccess(address));
    },
    [history, dispatch],
  );


  const handleAddressADD = useCallback(() => {
    history.push('/account/address');
    dispatch(customerCEPSuccess({} as UserAddresses));
  }, [history, dispatch]);

  return (
    <ContainerMyAddress>
      <MyAddressTitle>
        <AddressMore>{!summaryFlag && <FaLongArrowAltLeft />}</AddressMore>
        <span>{title}</span>
        <AddressMore>
          <FaLongArrowAltRight />
        </AddressMore>
      </MyAddressTitle>
      <ContainerAddressLists>
        {user.addresses &&
          user.addresses?.map(address => (
            <AddressItemContent key={address.id}>
              <AddressItem
                selected={address.selected}
                onClick={() => handleAddressSelected(address)}
              >
                <AddressTitle>
                  <span>{address.address_name}</span>
                </AddressTitle>
                <AddressLogo>
                  <FiHome size="48" color="var(--gray)" />
                </AddressLogo>
                <AddressStreet>
                  <span>
                    {address.address}
                    {address.number && `, ${address.number}`}
                  </span>
                </AddressStreet>
                <AddressNeigh>
                  <span>{address.neighborhood}</span>
                </AddressNeigh>
                <AddressCityState>
                  <AddressCity>
                    <span>{address.city}</span>
                  </AddressCity>
                  <AddressSeparator>-</AddressSeparator>
                  <AddressState>
                    <span>{address.state}</span>
                  </AddressState>
                </AddressCityState>
                <AddressZip>
                  <span>{address.postcode}</span>
                </AddressZip>
                <AddressAction>
                  <span>&nbsp;</span>
                </AddressAction>
              </AddressItem>
              <AddressItemUpdate>
                <AiOutlineEdit
                  title={t('main.card_address.btn_remove')}
                  onClick={() => handleAddressUpdate(address)}
                />
              </AddressItemUpdate>
              <AddressItemClosed>
                <AiOutlineClose
                  title={t('main.card_address.btn_remove')}
                  onClick={() => handleAddressRemoved(address.id)}
                />
              </AddressItemClosed>
            </AddressItemContent>
          ))}
        {!nobtnNew && (
          <>
            <AddressItemAdd onClick={handleAddressADD}>
              <AddressItemAddLogo>
                <FiPlus size="48" color="var(--green)" />
              </AddressItemAddLogo>
              <AddressItemAddText>
                <span>Adicionar Novo Endereço</span>
              </AddressItemAddText>
            </AddressItemAdd>
          </>
        )}
      </ContainerAddressLists>
    </ContainerMyAddress>
  );
};

export default CardAddress;
